import script from "./sidebar1.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebar1.vue?vue&type=script&setup=true&lang=js"

import "./sidebar1.vue?vue&type=style&index=0&id=7665635e&lang=css"

const __exports__ = script;

export default __exports__